import React from 'react';
import PropTypes from 'prop-types';
import url from 'url';

const withBackLink = (WrappedComponent, name) => {
  class WithBackLinkComponent extends React.Component {
    static propTypes = {
      withTransition: PropTypes.bool,
      animationRunning: PropTypes.bool,
      logoStore: PropTypes.object.isRequired,
    };

    componentDidMount() {
      const urlData = url.parse(location.href);
      if (urlData.pathname === `/${name}`) {
        this.fromPath = urlData.path;
      }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.withTransition && nextProps.animationRunning !== this.props.animationRunning) {
        if (!nextProps.animationRunning) {
          this.props.logoStore.setText(`Back to ${name}`);
          const path = this.fromPath || `/${name}`;
          this.props.logoStore.setPath(path);
        }
      }
    }

    componentWillUnmount() {
      this.props.logoStore.resetToDefaults();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithBackLinkComponent;
};

export default name => WrappedComponent => withBackLink(WrappedComponent, name);



// WEBPACK FOOTER //
// ./src/components/withBackLink.js